import React from 'react';
import { motion } from 'framer-motion';

const SearchBar = ({ searchTerm, onSearchChange }) => {
  return (
    <div className="search-container">
      <motion.div 
        className="search-wrapper"
        whileHover={{ scale: 1.02 }}
        whileFocus={{ scale: 1.02 }}
      >
        <input
          type="text"
          placeholder="Search for tools across the universe..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
        <div className="search-icon">🔍</div>
      </motion.div>
    </div>
  );
};

export default SearchBar;